<template>

  <main class="special-page">

    <header class="page-head">
      <h1>رویدادهای ویژه</h1>
      <p>پوشش اختصاصی رویدادهای بزرگ ورزش — جام جهانی، المپیک، بازی‌های آسیایی و…</p>
    </header>

      <!-- حالت لودینگ -->
      <div v-if="loading" class="state-box">در حال بارگذاری…</div>

      <!-- حالت خالی — زیرساخت آماده است، محتوا بعداً اضافه می‌شود -->
      <div v-else-if="!events.length" class="state-box empty">
        <span class="empty-icon">🏆</span>
        <p>به‌زودی رویدادهای ویژه اینجا اعلام می‌شوند.</p>
      </div>

      <!-- کارت‌های رویداد -->
      <div v-else class="events-grid">

        <router-link
            v-for="ev in events"
            :key="ev.id"
            class="event-card"
            :to="`/special/${ev.slug}`"
        >

          <div class="event-media">
            <img v-if="ev.imageUrl" :src="ev.imageUrl" :alt="ev.title" loading="lazy">
            <span v-else class="media-fallback">🏆</span>
          </div>

          <div class="event-body">
            <h2>{{ ev.title }}</h2>
            <p v-if="ev.subtitle" class="subtitle">{{ ev.subtitle }}</p>
            <span v-if="dateRange(ev)" class="dates">{{ dateRange(ev) }}</span>
          </div>

        </router-link>

      </div>

  </main>

</template>

<script>
import api from '@/services/api'
import { setSeo } from '@/utils/seo'

export default {

  name: 'SpecialEvents',

  data() {
    return {
      events: [],
      loading: true
    }
  },

  async created() {
    setSeo({
      title: 'رویدادهای ویژه | جام جهانی، المپیک و بازی‌های آسیایی | ضربه آزاد',
      description: 'پوشش ویژهٔ رویدادهای بزرگ ورزش — جام جهانی، المپیک، بازی‌های آسیایی و لیگ ملت‌ها در ضربه آزاد',
      path: '/special',
    })

    try {
      this.events = await api.request('/events') || []
    } catch (e) {
      console.error('SpecialEvents:', e)
      this.events = []
    } finally {
      this.loading = false
    }
  },

  methods: {
    dateRange(ev) {
      const fmt = d => new Date(d).toLocaleDateString('fa-IR')
      if (ev.startDate && ev.endDate) return `${fmt(ev.startDate)} تا ${fmt(ev.endDate)}`
      if (ev.startDate) return fmt(ev.startDate)
      return ''
    }
  }

}

</script>

<style scoped lang="scss">

.special-page {
  width: 100%;
  margin: 0 auto;
  padding: 24px 16px;
  box-sizing: border-box;
}

.page-head {
  margin-bottom: 24px;

  h1 {
    margin: 0 0 6px;
    font-size: 1.5rem;
    color: #0f172a;
  }

  p {
    margin: 0;
    color: #64748b;
    font-size: 0.95rem;
  }
}

.state-box {
  padding: 48px 16px;
  text-align: center;
  color: #64748b;
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 10px 25px rgba(0, 0, 0, .05);

  &.empty .empty-icon {
    display: block;
    font-size: 2.4rem;
    margin-bottom: 10px;
  }
}

.events-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(260px, 1fr));
  gap: 16px;
}

.event-card {
  display: flex;
  flex-direction: column;
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
  text-decoration: none;
  box-shadow: 0 10px 25px rgba(0, 0, 0, .05);
  transition: transform .2s ease, box-shadow .2s ease;

  &:hover {
    transform: translateY(-3px);
    box-shadow: 0 14px 30px rgba(0, 0, 0, .1);
  }
}

.event-media {
  height: 150px;
  background: linear-gradient(135deg, #022c22 0%, #064e3b 45%, #047857 85%, #059669 100%);
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .media-fallback {
    font-size: 2.6rem;
  }
}

.event-body {
  padding: 14px 16px 16px;

  h2 {
    margin: 0 0 6px;
    font-size: 1.05rem;
    color: #0f172a;
  }

  .subtitle {
    margin: 0 0 8px;
    font-size: 0.85rem;
    color: #64748b;
  }

  .dates {
    font-size: 0.8rem;
    color: #42d392;
    font-weight: 600;
  }
}

/* موبایل — بدون اسکرول افقی */
@media (max-width: 768px) {
  .special-page {
    padding: 16px 12px;
  }

  .events-grid {
    grid-template-columns: 1fr;
    gap: 12px;
  }
}

</style>
